@if(currentUserSvc.currentUser && toggleOn) {
    @if(currentUserSvc.currentUser.inAgency) {
        <app-agent-dashboard-page></app-agent-dashboard-page>
    } @else {
        <app-omc-dashboard></app-omc-dashboard>
    }
} @else {
    <app-home-page-component></app-home-page-component>
}
